module.exports = __webpack_public_path__ + "img/patrick-smc.30f9d15e.jpg";